export const ItemBooking = () => {

    return (
        <>
            <div id="booking-widget-anchor" class="boxed-widget booking-widget margin-top-35">
                <h3><i class="fa fa-calendar-check-o "></i> Booking</h3>
                <div class="row with-forms  margin-top-0">

                    {/* <!-- Date Range Picker - docs: http://www.daterangepicker.com/ --> */}
                    <div class="col-lg-12">
                        <input type="date" id="date-picker" placeholder="Date" readonly="readonly" />
                    </div>

                    {/* <!-- Panel Dropdown --> */}
                    <div class="col-lg-12">
                        <div class="panel-dropdown time-slots-dropdown">
                            <a href="#">Time Slots</a>
                            <div class="panel-dropdown-content padding-reset">
                                <div class="panel-dropdown-scrollable">

                                    {/* <!-- Time Slot --> */}
                                    <div class="time-slot">
                                        <input type="radio" name="time-slot" id="time-slot-1" />
                                        <label for="time-slot-1">
                                            <strong>8:30 am - 9:00 am</strong>
                                            <span>1 slot available</span>
                                        </label>
                                    </div>

                                    {/* <!-- Time Slot --> */}
                                    <div class="time-slot">
                                        <input type="radio" name="time-slot" id="time-slot-2" />
                                        <label for="time-slot-2">
                                            <strong>9:00 am - 9:30 am</strong>
                                            <span>2 slots available</span>
                                        </label>
                                    </div>

                                    {/* <!-- Time Slot --> */}
                                    <div class="time-slot">
                                        <input type="radio" name="time-slot" id="time-slot-3" />
                                        <label for="time-slot-3">
                                            <strong>9:30 am - 10:00 am</strong>
                                            <span>1 slots available</span>
                                        </label>
                                    </div>

                                    {/* <!-- Time Slot --> */}
                                    <div class="time-slot">
                                        <input type="radio" name="time-slot" id="time-slot-4" />
                                        <label for="time-slot-4">
                                            <strong>10:00 am - 10:30 am</strong>
                                            <span>3 slots available</span>
                                        </label>
                                    </div>

                                    {/* <!-- Time Slot --> */}
                                    <div class="time-slot">
                                        <input type="radio" name="time-slot" id="time-slot-5" />
                                        <label for="time-slot-5">
                                            <strong>13:00 pm - 13:30 pm</strong>
                                            <span>2 slots available</span>
                                        </label>
                                    </div>

                                    {/* <!-- Time Slot --> */}
                                    <div class="time-slot">
                                        <input type="radio" name="time-slot" id="time-slot-6" />
                                        <label for="time-slot-6">
                                            <strong>13:30 pm - 14:00 pm</strong>
                                            <span>1 slots available</span>
                                        </label>
                                    </div>

                                    {/* <!-- Time Slot --> */}
                                    <div class="time-slot">
                                        <input type="radio" name="time-slot" id="time-slot-7" />
                                        <label for="time-slot-7">
                                            <strong>14:00 pm - 14:30 pm</strong>
                                            <span>1 slots available</span>
                                        </label>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Panel Dropdown / End --> */}

                    {/* <!-- Panel Dropdown --> */}
                    <div class="col-lg-12">
                        <div class="panel-dropdown">
                            <a href="#">Guests <span class="qtyTotal" name="qtyTotal">1</span></a>
                            <div class="panel-dropdown-content">

                                {/* <!-- Quantity Buttons --> */}
                                <div class="qtyButtons">
                                    <div class="qtyTitle">Adults</div>
                                    <input type="text" name="qtyInput" value="1" />
                                </div>

                                <div class="qtyButtons">
                                    <div class="qtyTitle">Childrens</div>
                                    <input type="text" name="qtyInput" value="0" />
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* <!-- Panel Dropdown / End --> */}

                </div>

                {/* <!-- Book Now --> */}
                <a href="pages-booking.html" class="button book-now fullwidth margin-top-5">Request To Book</a>
            </div>
        </>
    )
}